function required(value) {
    return !!value;
}

function notEmpty(value) {
    return Array.isArray(value) && !!value.length;
}

function maxLength(length) {
    return value => value.length < length;
}

export default {
    data() {
        return {
            rules: {
                required: value => required(value) || this.$t('requiredField'),
                notEmpty: value => notEmpty(value) || this.$t('requiredField'),
                maxLength: length => value => maxLength(length)(value) || this.$t('longField'),
            },
            validators: {
                required,
                notEmpty,
                maxLength,
            },
        }
    },
    methods: {
        isAllValidatorsPassed(validators, value) {
            return validators.every(validator => validator(value));
        },
    },
}
